import { render } from "./SpddMingXi.vue?vue&type=template&id=69167c36&scoped=true"
import script from "./SpddMingXi.vue?vue&type=script&lang=js"
export * from "./SpddMingXi.vue?vue&type=script&lang=js"

import "./SpddMingXi.vue?vue&type=style&index=0&id=69167c36&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69167c36"]])

export default __exports__